// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestListBody = {
  poolId: string;
  seasonId?: string | null;
};

export type typeContestListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      contestId: string;
      name: string;
      startDate: string;
      endDate: string;
      status:
        "upcoming" | "active" | "pendingOutcome" | "confirmed" | "cancelled";
      endDateMode: "date" | "tbd";
      canDelete: boolean;
    }[];
    total: number;
    nextCursor?: string | null;
    viewerContestId?: string | null;
    viewerContestState: "playing" | "waiting" | "spectating" | "none";
  };
};

export type typeContestListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestListBody);
  }

  return async function postContestList(
    payload: typeContestListBody,
  ): Promise<typeContestListOutput200 | typeContestListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestList" failed before calling the network. #12e45336297b`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#12e45336297b" },
        },
        data: null,
      } as typeContestListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/list`,
      httpMethod: "POST",
      options,
    })) as typeContestListOutput200 | typeContestListOutput400;
  };
}
